import { keyframes } from "styled-components"

export interface WinNotificationProps {
  type: string
  player_id: string
  player_name: string
  index: string
  state: number
  bet: number
  coeff: number
  cashout: number
  currency: string
}

export interface moveProps {
  moveOne: boolean
  moveTwo: boolean
}

export interface WinNotificationEachProps {
  data: WinNotificationProps
  length: number
  which: number
  move: {
    moveOne: boolean
    moveTwo: boolean
  }
  prec: number
}

export interface win_notification_body {
  length: number
  which: number
  move: {
    moveOne: boolean
    moveTwo: boolean
  }
}

// ესენი სტილებისთვის

export const moveup = keyframes`
    0% {    
            bottom: -10px;
            opacity: 0;
        }

    100% {
            bottom: 0;
            opacity: 1;
        }
`

export const moveDown = keyframes`
    0% {
            bottom: 0;
            opacity: 1;
        }

    100% {
            bottom: -10px;
            opacity: 0;
            display: none;
        }
`

export const moveDownOne = keyframes`
    0% {
            bottom: 0;
            opacity: 1;
            /* left: calc(50% - 65px); */
        }

    100% {
            bottom: -10px;
            /* left: calc(50% - 65px); */
            opacity: 0;
            display: none;
        }
`

export const moveDownTwo = keyframes`
    0% {
            bottom: 0;
            opacity: 1;
            /* left: calc(50% + 65px); */
        }

    100% {
            bottom: -10px;
            /* left: calc(50% + 65px); */
            opacity: 0;
            display: none;
        }
`

export const moveRight = keyframes`
    0% {
            left: 50%;
        }
        
    100% {
            left: calc(50% - 65px);
        }
`

export const jackpotAnim = keyframes`
    0% {    
            bottom: -10px;
            opacity: 0;
        }
    80% {
            bottom: 0;
            opacity: 1;
        }
    100% {
            bottom: -10px;
            opacity: 0;
            display: none;
    }
`
